'use client';

import AboutCardScroll from '@/components/ui/about-card-scroll';
import AboutStickyCardScroll from '@/components/ui/about-sticky-card-scroll';

export function WhatWeMake() {
    return (
        <>
            {/* Desktop view */}
            <div>
                <div className="hidden lg:block">
                    <AboutStickyCardScroll />
                </div>
                <div className="lg:hidden">
                    <AboutCardScroll />
                </div>
            </div>
        </>
    );
}

WhatWeMake.displayName = 'WhatWeMake';
export default WhatWeMake;
